import React, { useEffect, useState } from 'react';
import base_url from '../../../base_url';
import {localStorageUserKey} from '../../../local_storage_vars';
import { smartStorage } from "../../../smart_storage";
import axios from 'axios';
import { Spinner } from 'react-activity';

import { Elements } from '@stripe/react-stripe-js';
import { stripePromise } from '../../../stripe';
import CheckoutForm from '../../../components/main/CheckoutForm';


const MembershipPage = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [isLoading,setIsLoading] = useState(false);
  const [pageLoading,setPageLoading] = useState(true);
  const [membershipPlans,setmembershiPlans] = useState([]);
  const [hasMembership,setHasMembership] = useState(false);
  const [membershipDetails, setMembershipDetails] = useState({});

  const appearance = { theme: 'stripe' };
  const options = { appearance };

  const handlePlanSelect = (planId) => {
    setSelectedPlan(planId);
    setPageLoading(true)

    setTimeout(()=>{
      setPageLoading(false)
    },300)
  };

  const buy_free_trial_membership = async(duration,type)=>{
    setIsLoading(true)
    const user = await smartStorage.get(localStorageUserKey);
    
    const formData = new FormData();
    formData.append('endDate', duration);
    formData.append('type', type);

    
   await axios.post(`${base_url}/apis/user_membership/buy-membership`, formData, {
      headers: {
        "x-api-key": process.env.REACT_APP_API_KEY,
        "authorization": user,
        'Content-Type': 'multipart/form-data', // Set the content type for FormData
      },
    })
      .then(async(response) => {
         const responseData = response.data;

        if (response.status === 200) {
         
          alert(responseData.message);
          window.location = "/home"
        } else {
          alert(responseData.message);

        }

      setIsLoading(false)

      })
      .catch(err => {
        console.log(err)
        alert("Internal server error");
      setIsLoading(false)

      });
  }


  const fetchMembershipPlans = async()=>{
    const user = await smartStorage.get(localStorageUserKey);
    axios.get(`${base_url}/apis/membership/get-all-memberships`,{
      headers:{
        "x-api-key": process.env.REACT_APP_API_KEY,
        "authorization": user,
        'Content-Type': 'multipart/form-data',
      }
    })
    .then(res=>{
      if(res.status == 200){
        setmembershiPlans(res.data)
        setPageLoading(false)
      }else{
        alert(res.data.message)
      }
    })
    .catch(err=>{
      alert("Something Went Wrong");
    })
  }

  const CheckMembership = ()=>{
      const user = smartStorage.get(localStorageUserKey);
      fetch(base_url+'/apis/user_membership/user-membership-details',{
          method:'GET',
          headers:{
              "x-api-key":process.env.REACT_APP_API_KEY,
              "authorization":user
          }
        })
        .then(res=>res.json())
        .then(response=>{

          if(response.found == false){
            setHasMembership(false);
          } else {
            setHasMembership(true);
            setMembershipDetails(response.membership);
          }
        })
        .catch(error=>{
          alert("Something Went Wrong");
        })
  }


  useEffect(()=>{
    CheckMembership();
    fetchMembershipPlans();
  },[])
  
  return (
    <>
    {!hasMembership && <div className=" mt-2 border p-3">
      <h2>Membership Plans</h2>
      <br />
      {pageLoading == false?<div>
      <div className="row">
        {membershipPlans.map((plan,index) => (
          <div key={index} className="col-md-4 mb-3">
            <div className={`card ${selectedPlan === plan._id ? 'border-primary' : ''}`}>
              <div className="card-header">
                <h4>{plan.title}</h4>
              </div>
              <div className="card-body">
                <h5>${!plan.price?0:plan.price}/{plan.expiry_days} Days</h5>
                <p>{plan.description}</p>
              </div>
              <div className="card-footer text-center">
                <button
                  className="btn btn-primary"
                  onClick={() => handlePlanSelect(plan._id)}
                  disabled={selectedPlan === plan._id}
                >
                  {selectedPlan === plan._id ? 'Selected' : 'Select'}
                </button>
              </div>
            </div>

            
          </div>
        ))}

       
      </div> 
      
      {selectedPlan? 
        <div className="mt-4">
           
          {membershipPlans.find((plan) => plan._id === selectedPlan).type === "trial" &&
          <div className="border p-2 btn-success col-12 col-sm-12 col-md-12 col-lg-6 mt-3" 
              style={{width:'100%', borderRadius:5, color:'white', alignItems:'center',justifyContent:'center', 
                display:'inline-flex', flexDirection:'column', marginTop:10, marginBottom:10}}> 

          <h5>Selected Plan: {membershipPlans.find((plan) => plan._id === selectedPlan).title}</h5>
                      <div className='p-2' 
                            style={{width:'100%', backgroundColor:'white', padding:10, borderRadius:5, alignItems:'center', justifyContent:'center', 
                            display:'inline'}}> 
          <button
          className="btn btn-primary"
          onClick={() => buy_free_trial_membership(membershipPlans.find((plan) => plan._id === selectedPlan).expiry_days,membershipPlans.find((plan) => plan._id === selectedPlan).type)}
          disabled={isLoading}
          >
          {isLoading?<Spinner size={17} color='skyblue'/>:null} Get For Free
        </button>
        </div>
          </div>}

         {membershipPlans.find((plan) => plan._id === selectedPlan).type != "trial" &&   
         <div className="border p-2 btn-success col-12 col-sm-12 col-md-12 col-lg-6 mt-3" 
              style={{width:'100%', borderRadius:5, color:'white', alignItems:'center',justifyContent:'center', 
                display:'inline-flex', flexDirection:'column', marginTop:10, marginBottom:10}}> 
                  <Elements stripe={stripePromise} options={options}>
                     <h5>Selected Plan: {membershipPlans.find((plan) => plan._id === selectedPlan).title}</h5>
                      <div className='p-2' 
                            style={{width:'100%', backgroundColor:'white', padding:10, borderRadius:5, alignItems:'center', justifyContent:'center', 
                            display:'inline'}}> 
                    <CheckoutForm offerId={0} 
                                  handymanAccountId={process.env.REACT_APP_STRIPE_ACCT_ID} 
                                  type={membershipPlans.find((plan) => plan._id === selectedPlan).type}
                                  membership_duration={membershipPlans.find((plan) => plan._id === selectedPlan).expiry_days}
                                  membershipId={membershipPlans.find((plan) => plan._id === selectedPlan)._id}
                                  amount={membershipPlans.find((plan) => plan._id === selectedPlan).price * 100}
                                  handymanCommissionPercentage={0} 
                                  reason='membership_charges' /></div>
                  </Elements>
              </div> }
        </div>
      :null}
      
      </div>:<center><Spinner size={25} color='skyblue'/></center>}
     

      
    </div>}
    {hasMembership && <div className=" mt-2 border p-3">
      <h2>Your Membership Details</h2>
      <br />
      <div className="row">
        <div className="col-md-12">
          <h4>Membership Start Date: {new Date(membershipDetails.startDate).toLocaleDateString()}</h4>
          <h4>Membership End Date: {new Date(membershipDetails.endDate).toLocaleDateString()}</h4>
        </div>
      </div>
    </div>}
    </>
  );
};

export default MembershipPage;
